import metadata from './metadata.json';
export var ScoreMethod;
(function (ScoreMethod) {
    ScoreMethod["SCORE_SSD"] = "ssd";
    ScoreMethod["SCORE_NCC"] = "ncc";
    ScoreMethod["NONE"] = "None";
})(ScoreMethod || (ScoreMethod = {}));
;
// Adopt file_prefix logic from original notebook
// into prefix translation code.
export const getOptionsToPrefix = (options) => {
    let file_prefix = '';
    if (options.cropping) {
        file_prefix += 'cropped_';
    }
    if (options.colorize) {
        if (options.score != ScoreMethod.NONE) {
            file_prefix += options.score + '_';
        }
        file_prefix += 'color_';
        file_prefix += options.multiscale ? 'ms_' : 'ns_';
    }
    else {
        file_prefix += 'plate_';
    }
    if (file_prefix == '') {
        file_prefix = 'default_';
    }
    return file_prefix;
};
export const pickRandom = (arr) => {
    return arr[Math.floor(Math.random() * arr.length)];
};
export const checkOptionsNameMatch = (options, imname) => {
    return (getOptionsToPrefix(options) in metadata) && (imname in metadata[getOptionsToPrefix(options)]);
};
// Randomize options for randomize button
export const randomizeOptions = () => {
    return {
        score: pickRandom([ScoreMethod.NONE, ScoreMethod.SCORE_NCC, ScoreMethod.SCORE_SSD]),
        cropping: pickRandom([true, false]),
        multiscale: pickRandom([true, false]),
        colorize: pickRandom([true, false]),
    };
};
// All image names that were worked on
export const TIFImages = ['church', 'emir', 'harvesters', 'icon', 'lady', 'melons', 'self_portrait', 'three_generations', 'train', 'workshop'];
export const ExtraImages = ['prison', 'villager', 'interior', 'boulder', 'village'];
export const JPGImages = ['tobolsk', 'monastery', 'cathedral'];
export const RenderMetadata = metadata;
